module.exports = __webpack_public_path__ + "resource/img/mark.c7767ebd.png";